import {createSelector} from "@reduxjs/toolkit";
import {AppState} from "../store";
import {TNotification} from "../../types/redux/snackTypes";

type TNotificationsSelector = (state: AppState) => TNotification[];
export const notificationsSelector: TNotificationsSelector = createSelector(
    (state: AppState) => state.snack?.notifications,
    (x => x)
);